import type { FaireProductEntity } from "../../entity_types/product";

export const p_pjnt9g9dmg: FaireProductEntity = {
  token: "p_pjnt9g9dmg",
  type: "product",
  name: "Best Man Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/edac8e3f85de7b001a1e956b26645ccffb01471f2f209c28173c64a2d8bdfc9f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ec89887a3041d772e5d1950388639c85239b4d09493800b5ca1fc7fa4d790094.jpeg",
    "https://cdn.faire.com/fastly/3e69ec79e2a4637b0883b7dc7a6cc2b5e55d46a90e14790b4f903857313820da.jpeg",
    "https://cdn.faire.com/fastly/3939c9867e98def82bdff61083c489236c52c57662dbda2375eed30b3a29605d.jpeg",
    "https://cdn.faire.com/fastly/376b0eebd842006ef1c80e67235f32c62faf8961a309c751a6b2571fcfb5e865.jpeg",
    "https://cdn.faire.com/fastly/ca805d1bd97e9a58703088045108f7ef59da654ef7b414be2b8539b7725a3c27.jpeg"
  ],
  priceDollars: 6.75,
  description: "These socks are for the man who planned the bachelor party, did not hire any strippers, and kept the wedding rings safe until \"I do\". The perfect gift for the guy who knows exactly which stories belong in the wedding toast, which ones don't, and the courage to tell a few anyway.\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance.\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:36:31.167Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
